document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.mm-product-image-slider')

  sliders.forEach((slider) => {
    const track = slider.querySelector('.mm-product-image-slider__track')
    const prev = slider.querySelector('.mm-product-image-slider__arrow--prev')
    const next = slider.querySelector('.mm-product-image-slider__arrow--next')

    if (!track || !prev || !next) return

    const scrollToSlide = (direction) => {
      const slideWidth = track.clientWidth

      track.scrollBy({
        left: direction * slideWidth,
        behavior: 'smooth',
      })
    }

    prev.addEventListener('click', () => scrollToSlide(-1))
    next.addEventListener('click', () => scrollToSlide(1))
  })
})

document.addEventListener('change', (event) => {
  const input = event.target

  if (!input.matches('variant-selects input[type="radio"]')) return
  if (!input.name.includes('Color')) return

  const selectedColor = input.value.trim().toLowerCase()
  // const expectedAltEnding = `in ${selectedColor}`

  const slider = document.querySelector('.product-images-slider')
  if (!slider) return

  const slides = [
    ...slider.querySelectorAll(
      '.slick-slide:not(.slick-cloned) .product-media-item',
    ),
  ]

  const slideIndex = slides.findIndex((slide) => {
    const image = slide.querySelector('.main_slider_img')
    const imageAlt = image?.alt?.toLowerCase() || ''

    return imageAlt.includes(selectedColor)
  })

  if (slideIndex < 0) {
    console.warn(`No product image found for color: ${input.value}`)
    return
  }

  if (
    window.jQuery &&
    window.jQuery.fn?.slick &&
    window.jQuery(slider).hasClass('slick-initialized')
  ) {
    window.jQuery(slider).slick('slickGoTo', slideIndex, false)
  }
})

function formatMoney(cents) {
  if (window.Shopify?.formatMoney && window.mmMoneyFormat) {
    return window.Shopify.formatMoney(cents, window.mmMoneyFormat)
  }

  return `$${(cents / 100).toFixed(2)}`
}

const productJsonCache = {}

async function getSelectedProductJson(productUrl) {
  if (!productUrl) return null

  const url = `${productUrl}.js`

  if (productJsonCache[url]) return productJsonCache[url]

  const response = await fetch(url)
  if (!response.ok) return null

  const productJson = await response.json()
  productJsonCache[url] = productJson

  return productJson
}

function handleize(value) {
  return value
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
}

subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
  const variant = event?.data?.variant
  if (!variant) return

  const mainPrice = document.querySelector('#main-price')
  const compareAtPrice = document.querySelector('#compare-at-price')
  const discountPercentage = document.querySelector('#discount-percentage')

  if (mainPrice) {
    mainPrice.textContent = formatMoney(variant.price)
  }

  if (compareAtPrice) {
    compareAtPrice.textContent = variant.compare_at_price
      ? formatMoney(variant.compare_at_price)
      : ''
  }

  if (discountPercentage) {
    if (
      variant.compare_at_price &&
      variant.compare_at_price > variant.price
    ) {
      const discount = Math.round(
        ((variant.compare_at_price - variant.price) * 100) /
          variant.compare_at_price,
      )

      discountPercentage.textContent = `-${discount}% OFF`
      discountPercentage.style.display = ''
    } else {
      discountPercentage.textContent = ''
      discountPercentage.style.display = 'none'
    }
  }
})